export const API_URL = import.meta.env.VITE_API_BASE_URL || '';
export const MPAI_REPO = 'https://github.com/marketplaceai-ai/marketplace-ai/';

// Layout
export const MIN_CONTENT_WIDTH = '300px';

// Routes
export const EMPLOYER_HOME = '/account/organization';
export const PROVIDER_BASE = '/vault';
export const EMPLOYER_BASE = '/hlx';

export const PROVIDER_HLX_BASE = '/hlx';
export const PROVIDER_HLX_HOME = `${PROVIDER_HLX_BASE}/job-opportunities`;

export const PROVIDER_REGISTRATION_BASE = `/provider-registration`;

export const PROVIDER_AUTH_HOME = `${PROVIDER_BASE}/dashboard`;
export const EMPLOYER_AUTH_HOME = `${EMPLOYER_BASE}/dashboard`;
